//@flow
import React from "react";
import ImageLoading from "./ajax-loader-transparent.gif";

export function ButtonLoading() {
  return (
    <button disabled={"disabled"} className="loading">
      <img src={ImageLoading} />
    </button>
  );
}
